import script from "./ElementDataSourceInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ElementDataSourceInfo.vue?vue&type=script&setup=true&lang=js"

import "./ElementDataSourceInfo.vue?vue&type=style&index=0&id=ba316aac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba316aac"]])

export default __exports__